
export function VueSuperMethod(this: any, options?: any): any {
    /**
     * Making a proxy super method for calling Super.
     * This will applicatible for mixin methods and extended component methods
     */

    // Creating a Proxy instance with options. This options will be our class/mixin/component name
    return new Proxy(options, {
        get: (getopts, name): any => {
            // Checking if the given method is exist of method objects/list
            if (getopts.options.methods && name in getopts.options.methods) {
                // If YES? just call and return the data
                return getopts.options.methods[name].bind(this);
            }
        },
    });
}
